/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AdditionalPublicData,
  AudiovisualCreation,
  AudiovisualReportInfo,
  BlankMediaPeriodInfo,
  BlankMediaTypeImporterApplication,
  BlankMediaTypeProfessionalUserApplication,
  BlankMediaUserInfo,
  BooleanViewModel,
  ChangePasswordViewModel,
  ChoreographicCreation,
  CopyPortalLicenseClientEventsData,
  CopyPortalLicenseClientEventsResponse,
  CreatedNegotiatedContentResultOfSubmitCreationResponse,
  CreationClassExtended,
  CreationClassGroupedRightsData,
  EquipmentItemViewModel,
  Error,
  EventReportInfo,
  EventReportWithDataFilesInfo,
  IContentNegotiator,
  InvoiceListInfo,
  InvoiceTotalsInfo,
  ItemViewModel,
  LicenseHeaderBriefInfo,
  LicenseInvoicePlanListInfo,
  LicenseeInfo,
  LinkedPersonInfo,
  MusicalCreation,
  OAuthResultViewModel,
  PaginatedListOfBlankMediaPublicInfo,
  PaginatedListOfBlankMediaTypeCommonDataViewModel,
  PaginatedListOfChildLicenseObjectBriefInfo,
  PaginatedListOfCompletedLicenseBriefInfo,
  PaginatedListOfCreationInfo,
  PaginatedListOfInvoiceListInfo,
  PaginatedListOfLicenseBriefInfo,
  PaginatedListOfLicenseCreationInfo,
  PaginatedListOfLicenseInvoicePlanBriefInfo,
  PaginatedListOfPublicMusicalCreationInfo,
  PaginatedListOfPublicRightsHolderInfo,
  PasswordPolicySettingsViewModel,
  PersonAddressDataNewsletterAndDisclosureSettings,
  PersonBankAccountViewModel,
  PersonNewsletterAndDisclosureSettings,
  PersonTaxRateAndBalance,
  PortalAdditionalReportGroupViewModel,
  PortalAdditionalReportRequestViewModel,
  PortalAuthenticationResult,
  PortalSettingsViewModel,
  ProcessingStatussInfo,
  ProgramReportInfo,
  ProgramReportListInfo,
  PublicLendingCreation,
  RedirectViewModel,
  RequestChangePasswordViewModel,
  RightsHolderBandViewModel,
  RightsHolderInfoViewModel,
  RightsHolderMembershipStatusAndFee,
  RightsHoldersNamesViewModel,
  ShowsReportInfo,
  SubmitAudiovisualReport,
  SubmitBandViewModel,
  SubmitBlankMediaImporterApplication,
  SubmitBlankMediaProfessionalUserApplication,
  SubmitCreation,
  SubmitEventReport,
  SubmitEventReportWithDataFiles,
  SubmitProgramReport,
  SubmitPseudonymViewModel,
  SubmitShowsReport,
  UnidentifiedCreationInfo,
  UnidentifiedCreationProcessListInfo,
  VersionInfoViewModel,
  VisualCreation,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Api<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags BlankMediaUsers
   * @name BlankMediaUsersGetBlankMediaInfo
   * @summary Info about person/personContact BlankMedia
   * @request GET:/api/blank-media/info
   */
  blankMediaUsersGetBlankMediaInfo = (params: RequestParams = {}) =>
    this.request<BlankMediaUserInfo, any>({
      path: `/api/blank-media/info`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags BlankMediaUsers
   * @name BlankMediaUsersGetBlankMediaPeriodInfo
   * @summary Info about application availability to save in particular period
   * @request GET:/api/blank-media/period-info
   */
  blankMediaUsersGetBlankMediaPeriodInfo = (
    query?: {
      periodBlankMediaUseTypes?: ("Manufacturer" | "Importer" | "ProfessionalUser")[];
      /** @format int32 */
      periodBlankMediaTypeId?: number;
      /** @format date-time */
      periodDateFrom?: string;
      /** @format date-time */
      periodDateTo?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<BlankMediaPeriodInfo, any>({
      path: `/api/blank-media/period-info`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags BlankMediaUsers
   * @name BlankMediaUsersGetApplications
   * @summary Gets list of blank media applications
   * @request GET:/api/blank-media/applications
   */
  blankMediaUsersGetApplications = (
    query?: {
      /** @format int32 */
      filterStatus?: number;
      /** @format int32 */
      filterUseType?: number;
      /** @format int32 */
      filterPageIndex?: number;
      /** @format int32 */
      filterPageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<PaginatedListOfBlankMediaTypeCommonDataViewModel, any>({
      path: `/api/blank-media/applications`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags BlankMediaUsers
   * @name BlankMediaUsersGetImporterApplicationDataById
   * @summary Gets BlankMedia importer application by id
   * @request GET:/api/blank-media/applications/I/{id}
   */
  blankMediaUsersGetImporterApplicationDataById = (id: number, params: RequestParams = {}) =>
    this.request<BlankMediaTypeImporterApplication, any>({
      path: `/api/blank-media/applications/I/${id}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags BlankMediaUsers
   * @name BlankMediaUsersPostImporterApplicationData
   * @summary Saves BlankMedia importer application data
   * @request POST:/api/blank-media/applications/I
   */
  blankMediaUsersPostImporterApplicationData = (
    application: SubmitBlankMediaImporterApplication,
    params: RequestParams = {},
  ) =>
    this.request<number, any>({
      path: `/api/blank-media/applications/I`,
      method: "POST",
      body: application,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags BlankMediaUsers
   * @name BlankMediaUsersGetProfessionalUserApplicationDataById
   * @summary Gets BlankMedia professional user application by id
   * @request GET:/api/blank-media/applications/P/{id}
   */
  blankMediaUsersGetProfessionalUserApplicationDataById = (id: number, params: RequestParams = {}) =>
    this.request<BlankMediaTypeProfessionalUserApplication, any>({
      path: `/api/blank-media/applications/P/${id}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags BlankMediaUsers
   * @name BlankMediaUsersPostProfessionalApplicationData
   * @summary Saves BlankMedia professional user application data
   * @request POST:/api/blank-media/applications/P
   */
  blankMediaUsersPostProfessionalApplicationData = (
    application: SubmitBlankMediaProfessionalUserApplication,
    params: RequestParams = {},
  ) =>
    this.request<number, any>({
      path: `/api/blank-media/applications/P`,
      method: "POST",
      body: application,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags BlankMediaUsers
   * @name BlankMediaUsersGetInvoicePdf
   * @summary Get the pdf of an invoice by invoices uniqueId
   * @request GET:/api/blank-media/invoices/{uniqueId}/file
   */
  blankMediaUsersGetInvoicePdf = (uniqueId: string, params: RequestParams = {}) =>
    this.request<IContentNegotiator, any>({
      path: `/api/blank-media/invoices/${uniqueId}/file`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags BlankMediaUsers
   * @name BlankMediaUsersGetActivePersonByType
   * @summary Get a ItemViewModel list of active persons by {Dpa.Avis.Common.Enums.BlankMediaUseType} and period
   * @request GET:/api/blank-media/persons
   */
  blankMediaUsersGetActivePersonByType = (
    query?: {
      filterBlankMediaUseTypes?: ("Manufacturer" | "Importer" | "ProfessionalUser")[];
      /** @format int32 */
      filterBlankMediaTypeId?: number;
      /** @format date-time */
      filterDateFrom?: string;
      /** @format date-time */
      filterDateTo?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<ItemViewModel[], any>({
      path: `/api/blank-media/persons`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags BlankMediaUsers
   * @name BlankMediaUsersGetInvoiceXml
   * @summary Get the xml of an invoice by invoice's uniqueId
   * @request GET:/api/blank-media/invoices/{uniqueId}/xml
   */
  blankMediaUsersGetInvoiceXml = (uniqueId: string, params: RequestParams = {}) =>
    this.request<IContentNegotiator, any>({
      path: `/api/blank-media/invoices/${uniqueId}/xml`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Classifiers
   * @name ClassifiersGetCreationClassesForFilter
   * @summary Get a list of creation class info for use in a filter
   * @request GET:/api/classifiers/creation-classes
   */
  classifiersGetCreationClassesForFilter = (params: RequestParams = {}) =>
    this.request<ItemViewModel[], any>({
      path: `/api/classifiers/creation-classes`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Classifiers
   * @name ClassifiersGetCreationClassesWithGenresAndRoles
   * @summary Get a list of creation classes with genre and role info included
   * @request GET:/api/classifiers/creation-classes/extended
   */
  classifiersGetCreationClassesWithGenresAndRoles = (params: RequestParams = {}) =>
    this.request<CreationClassExtended[], any>({
      path: `/api/classifiers/creation-classes/extended`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Classifiers
   * @name ClassifiersGetCreationStatusListForFilter
   * @summary Get a list of creation status info for use in a filter
   * @request GET:/api/classifiers/creation-statuses
   */
  classifiersGetCreationStatusListForFilter = (params: RequestParams = {}) =>
    this.request<ItemViewModel[], any>({
      path: `/api/classifiers/creation-statuses`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Classifiers
   * @name ClassifiersGetCreationStatusListForFilterForUnidentified
   * @summary Get a list of creation status info for use in a filter with the unidentified creations
   * @request GET:/api/classifiers/creation-statuses/for-unidentified
   */
  classifiersGetCreationStatusListForFilterForUnidentified = (params: RequestParams = {}) =>
    this.request<ItemViewModel[], any>({
      path: `/api/classifiers/creation-statuses/for-unidentified`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Classifiers
   * @name ClassifiersGetPublicCreationClasses
   * @summary Get a list of public creation classes
   * @request GET:/api/classifiers/creation-classes/public
   */
  classifiersGetPublicCreationClasses = (params: RequestParams = {}) =>
    this.request<ItemViewModel[], any>({
      path: `/api/classifiers/creation-classes/public`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Classifiers
   * @name ClassifiersGetUnidentifiedCreationsCreationClasses
   * @summary Get a list of creation classes for unidentified creations registration
   * @request GET:/api/classifiers/creation-classes/unidentified-creations-registration
   */
  classifiersGetUnidentifiedCreationsCreationClasses = (params: RequestParams = {}) =>
    this.request<ItemViewModel[], any>({
      path: `/api/classifiers/creation-classes/unidentified-creations-registration`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Classifiers
   * @name ClassifiersGetPortalReportStatusTypes
   * @summary Get a ItemViewModel list of enum {Dpa.Avis.Common.Enums.PortalReportStatusType}  values
   * @request GET:/api/classifiers/portal-report-status-types
   */
  classifiersGetPortalReportStatusTypes = (params: RequestParams = {}) =>
    this.request<ItemViewModel[], any>({
      path: `/api/classifiers/portal-report-status-types`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Classifiers
   * @name ClassifiersGetBlankMediaUsesForFilter
   * @summary Get a ItemViewModel list of enum {Dpa.Avis.Common.Enums.BlankMediaUseType} values for filter form
   * @request GET:/api/classifiers/blank-media-uses/for-filter
   */
  classifiersGetBlankMediaUsesForFilter = (params: RequestParams = {}) =>
    this.request<ItemViewModel[], any>({
      path: `/api/classifiers/blank-media-uses/for-filter`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Classifiers
   * @name ClassifiersGetActiveEquipments
   * @summary Get a ItemViewModel list of enum {Dpa.Avis.Common.Enums.BlankMediaUseType} values for filter form
   * @request GET:/api/classifiers/equipments
   */
  classifiersGetActiveEquipments = (params: RequestParams = {}) =>
    this.request<EquipmentItemViewModel[], any>({
      path: `/api/classifiers/equipments`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Classifiers
   * @name ClassifiersGetCountries
   * @summary Get a ItemViewModel list of countries
   * @request GET:/api/classifiers/countries
   */
  classifiersGetCountries = (params: RequestParams = {}) =>
    this.request<ItemViewModel[], any>({
      path: `/api/classifiers/countries`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Licensees
   * @name LicenseesGetActiveLicenses
   * @summary Get list of active licenses for the current person
   * @request GET:/api/licensees/licenses
   */
  licenseesGetActiveLicenses = (
    query?: {
      filterLicenseNumberFilterType?: "StartsWith" | "Contains";
      filterLicenseNumber?: string;
      filterLicenseObjectNameFilterType?: "StartsWith" | "Contains";
      filterLicenseObjectName?: string;
      /** @format int32 */
      filterPageIndex?: number;
      /** @format int32 */
      filterPageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<PaginatedListOfLicenseBriefInfo, any>({
      path: `/api/licensees/licenses`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Licensees
   * @name LicenseesGetCompletedLicenses
   * @summary Get list of completed licenses for the current person
   * @request GET:/api/licensees/licenses/completed
   */
  licenseesGetCompletedLicenses = (
    query?: {
      filterLicenseNumberFilterType?: "StartsWith" | "Contains";
      filterLicenseNumber?: string;
      filterLicenseObjectNameFilterType?: "StartsWith" | "Contains";
      filterLicenseObjectName?: string;
      /** @format int32 */
      filterPageIndex?: number;
      /** @format int32 */
      filterPageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<PaginatedListOfCompletedLicenseBriefInfo, any>({
      path: `/api/licensees/licenses/completed`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Licensees
   * @name LicenseesGetChildLicenses
   * @summary Get a list of child licenses for a license header id
   * @request GET:/api/licensees/licenses/{licenseHeaderId}/child-licenses
   */
  licenseesGetChildLicenses = (
    licenseHeaderId: number,
    query?: {
      filterLicenseObjectNameFilterType?: "StartsWith" | "Contains";
      filterLicenseObjectName?: string;
      /** @format int32 */
      filterPageIndex?: number;
      /** @format int32 */
      filterPageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<PaginatedListOfChildLicenseObjectBriefInfo, any>({
      path: `/api/licensees/licenses/${licenseHeaderId}/child-licenses`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Licensees
   * @name LicenseesGetLicenseHeaderInfo
   * @summary Get short license header info
   * @request GET:/api/licensees/licenses/{licenseHeaderId}
   */
  licenseesGetLicenseHeaderInfo = (licenseHeaderId: number, params: RequestParams = {}) =>
    this.request<LicenseHeaderBriefInfo, any>({
      path: `/api/licensees/licenses/${licenseHeaderId}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Licensees
   * @name LicenseesGetInvoicesWithPaymentOwedForLicense
   * @summary Get a list of active invoices corresponding to a licenses
   * @request GET:/api/licensees/licenses/{licenseHeaderId}/invoices
   */
  licenseesGetInvoicesWithPaymentOwedForLicense = (licenseHeaderId: number, params: RequestParams = {}) =>
    this.request<InvoiceListInfo[], any>({
      path: `/api/licensees/licenses/${licenseHeaderId}/invoices`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Licensees
   * @name LicenseesGetInvoiceArchiveForLicense
   * @summary Get a paginated list of completed invoices corresponding to a license
   * @request GET:/api/licensees/licenses/{licenseHeaderId}/invoices/archive
   */
  licenseesGetInvoiceArchiveForLicense = (
    licenseHeaderId: number,
    query?: {
      /** @format int32 */
      filterPageIndex?: number;
      /** @format int32 */
      filterPageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<PaginatedListOfInvoiceListInfo, any>({
      path: `/api/licensees/licenses/${licenseHeaderId}/invoices/archive`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Licensees
   * @name LicenseesGetActiveReportsForLicense
   * @summary Get a list of currently active license invoice plans for a license
   * @request GET:/api/licensees/licenses/{licenseHeaderId}/reports
   */
  licenseesGetActiveReportsForLicense = (
    licenseHeaderId: number,
    query?: {
      /** @format int32 */
      filterPageIndex?: number;
      /** @format int32 */
      filterPageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<PaginatedListOfLicenseInvoicePlanBriefInfo, any>({
      path: `/api/licensees/licenses/${licenseHeaderId}/reports`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Licensees
   * @name LicenseesGetArchivedReportsForLicense
   * @summary Get a list of archived license invoice plans for a license
   * @request GET:/api/licensees/licenses/{licenseHeaderId}/reports/archive
   */
  licenseesGetArchivedReportsForLicense = (
    licenseHeaderId: number,
    query?: {
      /** @format int32 */
      filterPageIndex?: number;
      /** @format int32 */
      filterPageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<PaginatedListOfLicenseInvoicePlanBriefInfo, any>({
      path: `/api/licensees/licenses/${licenseHeaderId}/reports/archive`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Licensees
   * @name LicenseesGetLicenseDocument
   * @summary Gets license portal document by id
   * @request GET:/api/licensees/licenses/{licenseHeaderId}/document/{portalLicenseDocumentId}
   */
  licenseesGetLicenseDocument = (
    licenseHeaderId: number,
    portalLicenseDocumentId: number,
    params: RequestParams = {},
  ) =>
    this.request<IContentNegotiator, any>({
      path: `/api/licensees/licenses/${licenseHeaderId}/document/${portalLicenseDocumentId}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Licensees
   * @name LicenseesGetInvoicesWithPaymentOwed
   * @summary Get a list of invoices corresponding to active licenses for current person/personcontact
   * @request GET:/api/licensees/invoices
   */
  licenseesGetInvoicesWithPaymentOwed = (params: RequestParams = {}) =>
    this.request<InvoiceListInfo[], any>({
      path: `/api/licensees/invoices`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Licensees
   * @name LicenseesGetTotalPaymentOwed
   * @summary Get the total owed amount from person's invoices
   * @request GET:/api/licensees/invoices/total
   */
  licenseesGetTotalPaymentOwed = (params: RequestParams = {}) =>
    this.request<InvoiceTotalsInfo, any>({
      path: `/api/licensees/invoices/total`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Licensees
   * @name LicenseesGetInvoicePdf
   * @summary Get the pdf of an invoice by invoices uniqueId
   * @request GET:/api/licensees/invoices/{uniqueId}/file
   */
  licenseesGetInvoicePdf = (uniqueId: string, params: RequestParams = {}) =>
    this.request<IContentNegotiator, any>({
      path: `/api/licensees/invoices/${uniqueId}/file`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Licensees
   * @name LicenseesGetInvoiceArchive
   * @summary Get a paginated list of invoices corresponding to completed licenses for the current person/personcontact
   * @request GET:/api/licensees/invoices/archive
   */
  licenseesGetInvoiceArchive = (
    query?: {
      /** @format int32 */
      filterPageIndex?: number;
      /** @format int32 */
      filterPageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<PaginatedListOfInvoiceListInfo, any>({
      path: `/api/licensees/invoices/archive`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Licensees
   * @name LicenseesGetLicenseInvoicePlans
   * @summary Get a list of currently active license invoice plans for a person/peron contact
   * @request GET:/api/licensees/reports
   */
  licenseesGetLicenseInvoicePlans = (params: RequestParams = {}) =>
    this.request<LicenseInvoicePlanListInfo[], any>({
      path: `/api/licensees/reports`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Licensees
   * @name LicenseesGetLicenseeInfo
   * @summary If the person/person contact has any active licenses, invoices, license repots
   * @request GET:/api/licensees/info
   */
  licenseesGetLicenseeInfo = (params: RequestParams = {}) =>
    this.request<LicenseeInfo, any>({
      path: `/api/licensees/info`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Licensees
   * @name LicenseesGetAudiovisualEventReport
   * @summary Get data of an audiovisual event's report
   * @request GET:/api/licensees/licenses/{licenseHeaderId}/reports/3/{licenseInvoicePlanId}
   */
  licenseesGetAudiovisualEventReport = (
    licenseHeaderId: number,
    licenseInvoicePlanId: number,
    params: RequestParams = {},
  ) =>
    this.request<AudiovisualReportInfo, any>({
      path: `/api/licensees/licenses/${licenseHeaderId}/reports/3/${licenseInvoicePlanId}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Licensees
   * @name LicenseesPostAudiovisualEventReport
   * @summary Update data of an audiovisual event's report (license invoice plan)
   * @request POST:/api/licensees/licenses/{licenseHeaderId}/reports/3/{licenseInvoicePlanId}
   */
  licenseesPostAudiovisualEventReport = (
    licenseHeaderId: number,
    licenseInvoicePlanId: number,
    report: SubmitAudiovisualReport,
    params: RequestParams = {},
  ) =>
    this.request<void, any>({
      path: `/api/licensees/licenses/${licenseHeaderId}/reports/3/${licenseInvoicePlanId}`,
      method: "POST",
      body: report,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Licensees
   * @name LicenseesGetShowsEventReport
   * @summary Get data of a show's event's report
   * @request GET:/api/licensees/licenses/{licenseHeaderId}/reports/1/{licenseInvoicePlanId}
   */
  licenseesGetShowsEventReport = (licenseHeaderId: number, licenseInvoicePlanId: number, params: RequestParams = {}) =>
    this.request<ShowsReportInfo, any>({
      path: `/api/licensees/licenses/${licenseHeaderId}/reports/1/${licenseInvoicePlanId}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Licensees
   * @name LicenseesPostShowsEventReport
   * @summary Update data of a shows' event's report (license invoice plan)
   * @request POST:/api/licensees/licenses/{licenseHeaderId}/reports/1/{licenseInvoicePlanId}
   */
  licenseesPostShowsEventReport = (
    licenseHeaderId: number,
    licenseInvoicePlanId: number,
    report: SubmitShowsReport,
    params: RequestParams = {},
  ) =>
    this.request<void, any>({
      path: `/api/licensees/licenses/${licenseHeaderId}/reports/1/${licenseInvoicePlanId}`,
      method: "POST",
      body: report,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Licensees
   * @name LicenseesGetEventReportWithDataFiles
   * @summary Get data of an event's report with data file
   * @request GET:/api/licensees/licenses/{licenseHeaderId}/reports/4/{licenseInvoicePlanId}
   */
  licenseesGetEventReportWithDataFiles = (
    licenseHeaderId: number,
    licenseInvoicePlanId: number,
    params: RequestParams = {},
  ) =>
    this.request<EventReportWithDataFilesInfo, any>({
      path: `/api/licensees/licenses/${licenseHeaderId}/reports/4/${licenseInvoicePlanId}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Licensees
   * @name LicenseesPostEventReportWithDataFiles
   * @summary Update data of an event's report with data file (license invoice plan)
   * @request POST:/api/licensees/licenses/{licenseHeaderId}/reports/4/{licenseInvoicePlanId}
   */
  licenseesPostEventReportWithDataFiles = (
    licenseHeaderId: number,
    licenseInvoicePlanId: number,
    report: SubmitEventReportWithDataFiles,
    params: RequestParams = {},
  ) =>
    this.request<void, any>({
      path: `/api/licensees/licenses/${licenseHeaderId}/reports/4/${licenseInvoicePlanId}`,
      method: "POST",
      body: report,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Licensees
   * @name LicenseesGetLicenseCreations
   * @summary Get a filtered list of public creations
   * @request GET:/api/licensees/licenses/creations
   */
  licenseesGetLicenseCreations = (
    query?: {
      /** @format int32 */
      filterCreationClassId?: number;
      filterCreationName?: string;
      filterCreationNameFilterType?: "StartsWith" | "Contains";
      filterSearchAllNames?: boolean;
      filterRightsHolderName?: string;
      filterCreationBand?: string;
      /** @format int32 */
      filterPageIndex?: number;
      /** @format int32 */
      filterPageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<PaginatedListOfLicenseCreationInfo, any>({
      path: `/api/licensees/licenses/creations`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Licensees
   * @name LicenseesGetEventReport
   * @summary Get data of an event's report
   * @request GET:/api/licensees/licenses/{licenseHeaderId}/reports/2/{licenseInvoicePlanId}
   */
  licenseesGetEventReport = (licenseHeaderId: number, licenseInvoicePlanId: number, params: RequestParams = {}) =>
    this.request<EventReportInfo, any>({
      path: `/api/licensees/licenses/${licenseHeaderId}/reports/2/${licenseInvoicePlanId}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Licensees
   * @name LicenseesPostEventReport
   * @summary Update data of an event's report (license invoice plan)
   * @request POST:/api/licensees/licenses/{licenseHeaderId}/reports/2/{licenseInvoicePlanId}
   */
  licenseesPostEventReport = (
    licenseHeaderId: number,
    licenseInvoicePlanId: number,
    report: SubmitEventReport,
    params: RequestParams = {},
  ) =>
    this.request<void, any>({
      path: `/api/licensees/licenses/${licenseHeaderId}/reports/2/${licenseInvoicePlanId}`,
      method: "POST",
      body: report,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Licensees
   * @name LicenseesGetProgramReport
   * @summary Get program report's data
   * @request GET:/api/licensees/licenses/{licenseHeaderId}/reports/2/{licenseInvoicePlanId}/client-events/{licenseClientEventId}
   */
  licenseesGetProgramReport = (
    licenseHeaderId: number,
    licenseInvoicePlanId: number,
    licenseClientEventId: number,
    params: RequestParams = {},
  ) =>
    this.request<ProgramReportInfo, any>({
      path: `/api/licensees/licenses/${licenseHeaderId}/reports/2/${licenseInvoicePlanId}/client-events/${licenseClientEventId}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Licensees
   * @name LicenseesPostProgramReport
   * @summary Post program report's data
   * @request POST:/api/licensees/licenses/{licenseHeaderId}/reports/2/{licenseInvoicePlanId}/client-events/{licenseClientEventId}
   */
  licenseesPostProgramReport = (
    licenseHeaderId: number,
    licenseInvoicePlanId: number,
    licenseClientEventId: number,
    programReport: SubmitProgramReport,
    params: RequestParams = {},
  ) =>
    this.request<void, any>({
      path: `/api/licensees/licenses/${licenseHeaderId}/reports/2/${licenseInvoicePlanId}/client-events/${licenseClientEventId}`,
      method: "POST",
      body: programReport,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Licensees
   * @name LicenseesGetProgramReportsForCopyDestination
   * @summary Get a list of license client events with program reports info for copy destination list
   * @request GET:/api/licensees/licenses/client-events/{sourcePortalLicenseClientEventId}/copy/destinations
   */
  licenseesGetProgramReportsForCopyDestination = (
    sourcePortalLicenseClientEventId: number,
    params: RequestParams = {},
  ) =>
    this.request<ProgramReportListInfo[], any>({
      path: `/api/licensees/licenses/client-events/${sourcePortalLicenseClientEventId}/copy/destinations`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Licensees
   * @name LicenseesCopyLicenseClientEventProgramReport
   * @summary Copy a license client event's program report's data to another program report
   * @request POST:/api/licensees/licenses/client-events/{sourcePortalLicenseClientEventId}/copy
   */
  licenseesCopyLicenseClientEventProgramReport = (
    sourcePortalLicenseClientEventId: number,
    data: CopyPortalLicenseClientEventsData,
    params: RequestParams = {},
  ) =>
    this.request<CopyPortalLicenseClientEventsResponse, any>({
      path: `/api/licensees/licenses/client-events/${sourcePortalLicenseClientEventId}/copy`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Licensees
   * @name LicenseesGetInvoiceXml
   * @summary Get the xml of an invoice by invoice's uniqueId
   * @request GET:/api/licensees/invoices/{uniqueId}/xml
   */
  licenseesGetInvoiceXml = (uniqueId: string, params: RequestParams = {}) =>
    this.request<IContentNegotiator, any>({
      path: `/api/licensees/invoices/${uniqueId}/xml`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Log
   * @name LogPostErrorData
   * @summary Save log error data from web
   * @request POST:/api/log
   */
  logPostErrorData = (errorData: Error, params: RequestParams = {}) =>
    this.request<string, any>({
      path: `/api/log`,
      method: "POST",
      body: errorData,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Public
   * @name PublicGetBlankMediaImporters
   * @summary Get blank media importers list
   * @request GET:/api/public/blank-media/importers
   */
  publicGetBlankMediaImporters = (
    query?: {
      filterPersonNameOrTaxpayerCode?: string;
      filterPersonNameOrTaxpayerCodeFilterType?: "StartsWith" | "Contains";
      /** @format int32 */
      filterPageIndex?: number;
      /** @format int32 */
      filterPageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<PaginatedListOfBlankMediaPublicInfo, any>({
      path: `/api/public/blank-media/importers`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Public
   * @name PublicGetBlankMediaManufacturers
   * @summary Get blank media manufacturers list
   * @request GET:/api/public/blank-media/manufacturers
   */
  publicGetBlankMediaManufacturers = (
    query?: {
      filterPersonNameOrTaxpayerCode?: string;
      filterPersonNameOrTaxpayerCodeFilterType?: "StartsWith" | "Contains";
      /** @format int32 */
      filterPageIndex?: number;
      /** @format int32 */
      filterPageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<PaginatedListOfBlankMediaPublicInfo, any>({
      path: `/api/public/blank-media/manufacturers`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Public
   * @name PublicGetBlankMediaProfessionalUsers
   * @summary Get blank media professional users list
   * @request GET:/api/public/blank-media/professional-users
   */
  publicGetBlankMediaProfessionalUsers = (
    query?: {
      filterPersonNameOrTaxpayerCode?: string;
      filterPersonNameOrTaxpayerCodeFilterType?: "StartsWith" | "Contains";
      /** @format int32 */
      filterPageIndex?: number;
      /** @format int32 */
      filterPageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<PaginatedListOfBlankMediaPublicInfo, any>({
      path: `/api/public/blank-media/professional-users`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Public
   * @name PublicGetPublicMusicalCreations
   * @summary Get a paginated list of public creation data
   * @request GET:/api/public/creations/musical
   */
  publicGetPublicMusicalCreations = (
    query?: {
      filterCreationName?: string;
      filterCreationNameFilterType?: "StartsWith" | "Contains";
      filterSearchAllNames?: boolean;
      filterRightsHolderNameOrIpiNumber?: string;
      filterRightsHolderNameOrIpiNumberFilterType?: "StartsWith" | "Contains";
      /** @format int32 */
      filterPageIndex?: number;
      /** @format int32 */
      filterPageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<PaginatedListOfPublicMusicalCreationInfo, any>({
      path: `/api/public/creations/musical`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Public
   * @name PublicGetPublicRightsHolders
   * @summary Get a paginated list of public rights holders info
   * @request GET:/api/public/rights-holders
   */
  publicGetPublicRightsHolders = (
    query?: {
      /** @format int32 */
      filterCreationClassId?: number;
      filterRightsHolderName?: string;
      filterRightsHolderNameFilterType?: "StartsWith" | "Contains";
      /** @format int32 */
      filterPageIndex?: number;
      /** @format int32 */
      filterPageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<PaginatedListOfPublicRightsHolderInfo, any>({
      path: `/api/public/rights-holders`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Public
   * @name PublicGetPublicCreationClassesForRightsHolders
   * @summary Get a list of public creation classes (for use in a filter)
   * @request GET:/api/public/rights-holders/public-creation-classes
   */
  publicGetPublicCreationClassesForRightsHolders = (params: RequestParams = {}) =>
    this.request<ItemViewModel[], any>({
      path: `/api/public/rights-holders/public-creation-classes`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Public
   * @name PublicGetPublicRegisterUpdateDate
   * @summary Get any additional public data
   * @request GET:/api/public/additional-data
   */
  publicGetPublicRegisterUpdateDate = (params: RequestParams = {}) =>
    this.request<AdditionalPublicData, any>({
      path: `/api/public/additional-data`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Reports
   * @name ReportsGetPortalAdditionalReports
   * @summary Gets available portal additional report groups with reports
   * @request GET:/api/reports
   */
  reportsGetPortalAdditionalReports = (params: RequestParams = {}) =>
    this.request<PortalAdditionalReportGroupViewModel[], any>({
      path: `/api/reports`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Reports
   * @name ReportsDownloadPortalAdditionalReportFile
   * @summary Gets selected report file by name
   * @request POST:/api/reports
   */
  reportsDownloadPortalAdditionalReportFile = (
    reportParams: PortalAdditionalReportRequestViewModel,
    params: RequestParams = {},
  ) =>
    this.request<IContentNegotiator, any>({
      path: `/api/reports`,
      method: "POST",
      body: reportParams,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags RightsHolders
   * @name RightsHoldersGetRightsHoldersData
   * @summary Get all rights holders for the current person
   * @request GET:/api/rights-holders
   */
  rightsHoldersGetRightsHoldersData = (params: RequestParams = {}) =>
    this.request<RightsHolderInfoViewModel[], any>({
      path: `/api/rights-holders`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags RightsHolders
   * @name RightsHoldersGetRightsHolderNamesByRightsHolderId
   * @summary Get all rights holders names for the current user by a rights holder id
   * @request GET:/api/rights-holders/{rightsHolderId}/names
   */
  rightsHoldersGetRightsHolderNamesByRightsHolderId = (rightsHolderId: number, params: RequestParams = {}) =>
    this.request<RightsHoldersNamesViewModel[], any>({
      path: `/api/rights-holders/${rightsHolderId}/names`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags RightsHolders
   * @name RightsHoldersPostRightsHoldersName
   * @summary Add a pseudonym for a rights holder
   * @request POST:/api/rights-holders/{rightsHolderId}/names
   */
  rightsHoldersPostRightsHoldersName = (
    rightsHolderId: number,
    authorPseudonymViewModel: SubmitPseudonymViewModel,
    params: RequestParams = {},
  ) =>
    this.request<IContentNegotiator, any>({
      path: `/api/rights-holders/${rightsHolderId}/names`,
      method: "POST",
      body: authorPseudonymViewModel,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags RightsHolders
   * @name RightsHoldersGetBandsByRightsHolderId
   * @summary Get a list of bands info by rights holder id
   * @request GET:/api/rights-holders/{rightsHolderId}/bands
   */
  rightsHoldersGetBandsByRightsHolderId = (rightsHolderId: number, params: RequestParams = {}) =>
    this.request<RightsHolderBandViewModel[], any>({
      path: `/api/rights-holders/${rightsHolderId}/bands`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags RightsHolders
   * @name RightsHoldersPostRightsHoldersBand
   * @summary Add a band for a rights holder
   * @request POST:/api/rights-holders/{rightsHolderId}/bands
   */
  rightsHoldersPostRightsHoldersBand = (
    rightsHolderId: number,
    bandSubmitModel: SubmitBandViewModel,
    params: RequestParams = {},
  ) =>
    this.request<IContentNegotiator, any>({
      path: `/api/rights-holders/${rightsHolderId}/bands`,
      method: "POST",
      body: bandSubmitModel,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags RightsHolders
   * @name RightsHoldersGetDelegatedRights
   * @summary Gets object with update date and list of delegated/unassigned rights grouped by creationClasses and roles with same rights
   * @request GET:/api/rights-holders/{rightsHolderId}/delegated-rights
   */
  rightsHoldersGetDelegatedRights = (rightsHolderId: number, params: RequestParams = {}) =>
    this.request<CreationClassGroupedRightsData, any>({
      path: `/api/rights-holders/${rightsHolderId}/delegated-rights`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags RightsHolders
   * @name RightsHoldersGetRightsHolderFullRigthsDelegates
   * @summary Get rights holders linked persons with type "delegate with full rights"
   * @request GET:/api/rights-holders/{rightsHolderId}/linked-persons/full-rights-delegates
   */
  rightsHoldersGetRightsHolderFullRigthsDelegates = (rightsHolderId: number, params: RequestParams = {}) =>
    this.request<LinkedPersonInfo[], any>({
      path: `/api/rights-holders/${rightsHolderId}/linked-persons/full-rights-delegates`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags RightsHolders
   * @name RightsHoldersGetRightsHoldersBailiffs
   * @summary Get info if rights holder has any linked persons with type "bailiff"
   * @request GET:/api/rights-holders/{rightsHolderId}/linked-persons/bailiffs/any
   */
  rightsHoldersGetRightsHoldersBailiffs = (rightsHolderId: number, params: RequestParams = {}) =>
    this.request<BooleanViewModel, any>({
      path: `/api/rights-holders/${rightsHolderId}/linked-persons/bailiffs/any`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags RightsHolders
 * @name RightsHoldersGetPersonSettings
 * @summary Get info on person's contact data (addresses, phone, email),
and newsletter and disclosure settings.
 * @request GET:/api/rights-holders/person/settings
 */
  rightsHoldersGetPersonSettings = (params: RequestParams = {}) =>
    this.request<PersonAddressDataNewsletterAndDisclosureSettings, any>({
      path: `/api/rights-holders/person/settings`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags RightsHolders
   * @name RightsHoldersUpdatePersonSettings
   * @summary Update person's newsletter and disclosure settings
   * @request POST:/api/rights-holders/person/settings
   */
  rightsHoldersUpdatePersonSettings = (model: PersonNewsletterAndDisclosureSettings, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/rights-holders/person/settings`,
      method: "POST",
      body: model,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags RightsHolders
   * @name RightsHoldersGetPersonBankAccounts
   * @summary Get person's bank accounts info
   * @request GET:/api/rights-holders/person/bank-accounts
   */
  rightsHoldersGetPersonBankAccounts = (params: RequestParams = {}) =>
    this.request<PersonBankAccountViewModel[], any>({
      path: `/api/rights-holders/person/bank-accounts`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags RightsHolders
   * @name RightsHoldersGetPersonTaxAndBalanceInfo
   * @summary Get the tax rate name, value and balance for a person
   * @request GET:/api/rights-holders/person/billing-data
   */
  rightsHoldersGetPersonTaxAndBalanceInfo = (params: RequestParams = {}) =>
    this.request<PersonTaxRateAndBalance, any>({
      path: `/api/rights-holders/person/billing-data`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags RightsHolders
   * @name RightsHoldersGetRightsHolderMembershipStatusAndFee
   * @summary Rights holder's organization membership info
   * @request GET:/api/rights-holders/{rightsHolderId}/membership-status
   */
  rightsHoldersGetRightsHolderMembershipStatusAndFee = (rightsHolderId: number, params: RequestParams = {}) =>
    this.request<RightsHolderMembershipStatusAndFee, any>({
      path: `/api/rights-holders/${rightsHolderId}/membership-status`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags RightsHolders
   * @name RightsHoldersGetCreationsList
   * @summary Get creations list
   * @request GET:/api/rights-holders/{rightsHolderId}/creations
   */
  rightsHoldersGetCreationsList = (
    rightsHolderId: number,
    query?: {
      /** @format int32 */
      filterCreationClassId?: number;
      /** @format int32 */
      filterCreationStatusId?: number;
      filterCreationName?: string;
      filterCreationNameFilterType?: "StartsWith" | "Contains";
      filterSearchAllNames?: boolean;
      filterForUnidentifiedCreations?: boolean;
      /** @format int32 */
      filterPageIndex?: number;
      /** @format int32 */
      filterPageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<PaginatedListOfCreationInfo, any>({
      path: `/api/rights-holders/${rightsHolderId}/creations`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags RightsHolders
   * @name RightsHoldersAddCreation
   * @summary Add a new creation
   * @request POST:/api/rights-holders/{rightsHolderId}/creations
   */
  rightsHoldersAddCreation = (rightsHolderId: number, creation: SubmitCreation, params: RequestParams = {}) =>
    this.request<CreatedNegotiatedContentResultOfSubmitCreationResponse, any>({
      path: `/api/rights-holders/${rightsHolderId}/creations`,
      method: "POST",
      body: creation,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags RightsHolders
   * @name RightsHoldersGetMusicalCreation
   * @summary Get musical creation
   * @request GET:/api/rights-holders/{rightsHolderId}/creations/m/{creationId}
   */
  rightsHoldersGetMusicalCreation = (rightsHolderId: number, creationId: number, params: RequestParams = {}) =>
    this.request<MusicalCreation, any>({
      path: `/api/rights-holders/${rightsHolderId}/creations/m/${creationId}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags RightsHolders
   * @name RightsHoldersGetAudiovisualCreation
   * @summary Get audiovisual creation
   * @request GET:/api/rights-holders/{rightsHolderId}/creations/av/{creationId}
   */
  rightsHoldersGetAudiovisualCreation = (rightsHolderId: number, creationId: number, params: RequestParams = {}) =>
    this.request<AudiovisualCreation, any>({
      path: `/api/rights-holders/${rightsHolderId}/creations/av/${creationId}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags RightsHolders
   * @name RightsHoldersGetChoreographicCreation
   * @summary Get choreographic creation
   * @request GET:/api/rights-holders/{rightsHolderId}/creations/h/{creationId}
   */
  rightsHoldersGetChoreographicCreation = (rightsHolderId: number, creationId: number, params: RequestParams = {}) =>
    this.request<ChoreographicCreation, any>({
      path: `/api/rights-holders/${rightsHolderId}/creations/h/${creationId}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags RightsHolders
   * @name RightsHoldersGetPublicLendingCreation
   * @summary Get public lending creation
   * @request GET:/api/rights-holders/{rightsHolderId}/creations/ppi/{creationId}
   */
  rightsHoldersGetPublicLendingCreation = (rightsHolderId: number, creationId: number, params: RequestParams = {}) =>
    this.request<PublicLendingCreation, any>({
      path: `/api/rights-holders/${rightsHolderId}/creations/ppi/${creationId}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags RightsHolders
   * @name RightsHoldersGetVisualCreation
   * @summary Get visual creation
   * @request GET:/api/rights-holders/{rightsHolderId}/creations/v/{creationId}
   */
  rightsHoldersGetVisualCreation = (rightsHolderId: number, creationId: number, params: RequestParams = {}) =>
    this.request<VisualCreation, any>({
      path: `/api/rights-holders/${rightsHolderId}/creations/v/${creationId}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags RightsHolders
   * @name RightsHoldersGetUnidentifiedCreationList
   * @summary Get a list of unidentified creation processes for a rights holder
   * @request GET:/api/rights-holders/{rightsHolderId}/unidentified-creation-processes
   */
  rightsHoldersGetUnidentifiedCreationList = (rightsHolderId: number, params: RequestParams = {}) =>
    this.request<UnidentifiedCreationProcessListInfo[], any>({
      path: `/api/rights-holders/${rightsHolderId}/unidentified-creation-processes`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags RightsHolders
   * @name RightsHoldersGetUnidentifiedCreation
   * @summary Get an unidentified creation info by id
   * @request GET:/api/rights-holders/{rightsHolderId}/unidentified-creation-processes/{unidentifiedCreationProcessId}
   */
  rightsHoldersGetUnidentifiedCreation = (
    rightsHolderId: number,
    unidentifiedCreationProcessId: number,
    params: RequestParams = {},
  ) =>
    this.request<UnidentifiedCreationInfo, any>({
      path: `/api/rights-holders/${rightsHolderId}/unidentified-creation-processes/${unidentifiedCreationProcessId}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags RightsHolders
   * @name RightsHoldersPostUnidentifiedCreationStatus
   * @summary Post the info on whether the rights holder recognizes the unidentified creation
   * @request POST:/api/rights-holders/{rightsHolderId}/unidentified-creation-processes/{unidentifiedCreationProcessId}/status
   */
  rightsHoldersPostUnidentifiedCreationStatus = (
    rightsHolderId: number,
    unidentifiedCreationProcessId: number,
    processingInfo: ProcessingStatussInfo,
    params: RequestParams = {},
  ) =>
    this.request<void, any>({
      path: `/api/rights-holders/${rightsHolderId}/unidentified-creation-processes/${unidentifiedCreationProcessId}/status`,
      method: "POST",
      body: processingInfo,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Security
   * @name SecurityClaims
   * @summary Gets Authorization metadata about current user
   * @request GET:/api/security/claims
   */
  securityClaims = (params: RequestParams = {}) =>
    this.request<PortalAuthenticationResult, any>({
      path: `/api/security/claims`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Security
   * @name SecurityChangePassword
   * @summary Change password action
   * @request POST:/api/security/change-password
   */
  securityChangePassword = (model: ChangePasswordViewModel, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/security/change-password`,
      method: "POST",
      body: model,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Security
   * @name SecurityRequestChangePassword
   * @summary Request change password (with eId)
   * @request POST:/api/security/request-change-password
   */
  securityRequestChangePassword = (model: RequestChangePasswordViewModel, params: RequestParams = {}) =>
    this.request<RedirectViewModel, any>({
      path: `/api/security/request-change-password`,
      method: "POST",
      body: model,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags Security
 * @name SecurityConfirmPasswordEId
 * @summary Confirm password endpoint. Must call this after getting back from eID to /eId/ConfirmPassword.
If this completes without error - action completed successfully
 * @request POST:/api/security/confirm-change-password
 */
  securityConfirmPasswordEId = (model: OAuthResultViewModel, params: RequestParams = {}) =>
    this.request<RedirectViewModel, any>({
      path: `/api/security/confirm-change-password`,
      method: "POST",
      body: model,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Security
   * @name SecurityAcceptUseTerms
   * @summary Accept use-terms
   * @request POST:/api/security/accept-use-terms
   */
  securityAcceptUseTerms = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/security/accept-use-terms`,
      method: "POST",
      ...params,
    });
  /**
   * No description
   *
   * @tags Security
   * @name SecurityPasswordSettings
   * @summary Gets required password settings
   * @request GET:/api/security/password-settings
   */
  securityPasswordSettings = (params: RequestParams = {}) =>
    this.request<PasswordPolicySettingsViewModel, any>({
      path: `/api/security/password-settings`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Security
   * @name SecurityPortalSettings
   * @summary Gets portal settings
   * @request GET:/api/security/portal-settings
   */
  securityPortalSettings = (params: RequestParams = {}) =>
    this.request<PortalSettingsViewModel, any>({
      path: `/api/security/portal-settings`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Texts
   * @name TextsGetTextToDisplay
   * @summary Gets all texts-to-display collection filtered by portalType
   * @request GET:/api/texts/text-to-display
   */
  textsGetTextToDisplay = (
    query: {
      portalType: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Record<string, string>, any>({
      path: `/api/texts/text-to-display`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Texts
   * @name TextsGetResources
   * @summary Gets all resource key-value collection filtered by portalType
   * @request GET:/api/texts/resources
   */
  textsGetResources = (
    query: {
      portalType: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Record<string, string>, any>({
      path: `/api/texts/resources`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Version
   * @name VersionGet
   * @summary Get API assembly version
   * @request GET:/api/version
   */
  versionGet = (params: RequestParams = {}) =>
    this.request<VersionInfoViewModel, any>({
      path: `/api/version`,
      method: "GET",
      format: "json",
      ...params,
    });
}
